<div *ngIf="business.description || (editModeSet)" class="section">
  <div class="section__header">
    <h2 class="section__header-text">Business Description <mat-icon (click)="openEditDescDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon></h2>
  </div>
  <div class="section__body">
    <div class="section__content business-desc__content" *ngIf="business.description; else please">
      {{ business.description }}
    </div>
  </div>
</div>

<ng-template #please>
  <div class="section__content business-desc__content">None Entered</div>
</ng-template>
